"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _display$zIndex$justi;
var _default = exports["default"] = (_display$zIndex$justi = {
  display: 'flex',
  zIndex: 'layer8',
  justifyContent: 'center',
  alignItems: {
    base: 'flex-end',
    tablet: 'center'
  },
  height: '100%',
  minHeight: '-moz-available'
}, (0, _defineProperty2["default"])(_display$zIndex$justi, "minHeight", '-webkit-fill-available'), (0, _defineProperty2["default"])(_display$zIndex$justi, "minHeight", 'fill-available'), _display$zIndex$justi);